import React, { useState } from 'react';
import Deletebutton from '../../../components/buttons/deletebutton/Deletebutton';

const Editfield = ({ method, f }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{
        display: 'flex',
        width: '50%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {show && (
        <div onClick={() => method(f)}>
          <Deletebutton />
        </div>
      )}
      {!show && (<label>{f}</label>)}
    </div>
  );
};

export default Editfield;
